export class PinsParams {
  pin: string
  resetPin: string

  constructor({ pin, resetPin }: { pin: string, resetPin: string }) {
    this.pin = pin
    this.resetPin = resetPin
  }
}
